import _ from 'lodash';
import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  // current user subscriptions
  weatherTimeZones: [],
  subscriptions: [],
  accountId: 0,
  accountName: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PUBLIC_PROFILE.SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case actionTypes.MAP_PHONE_TO_SUBMIT.SUCCESS: {
      const { smsValidate, phoneValidate } = action.payload.payload;
      const { privateUserInfo } = state;
      if (privateUserInfo) {
        const { deliverPathInfo: {
          phoneInfo, SMSInfo
        } } = privateUserInfo;
        if (phoneValidate !== undefined) {
          phoneInfo.noValidate = phoneValidate;
        }
        if (smsValidate !== undefined) {
          SMSInfo.noValidate = smsValidate;
        }

        if (smsValidate !== undefined) {
          return {
            ...state,
            privateUserInfo,
            smsValidate,
          };
        }
        if (phoneValidate !== undefined) {
          return {
            ...state,
            privateUserInfo,
            phoneValidate,
          };
        }

        return {
          ...state,
          privateUserInfo,
        };
      }

      if (smsValidate !== undefined) {
        return {
          ...state,
          smsValidate,
        };
      }
      if (phoneValidate !== undefined) {
        return {
          ...state,
          phoneValidate,
        };
      }

      return {
        ...state,
      };
    }
    case actionTypes.GET_CURRENT_USER_INIT.SUCCESS: {
      const { accountId, accountName } = action.payload;
      return {
        ...state,
        accountId,
        accountName,
      };
    }
    case actionTypes.GET_SUBSCRIPTIONS.SUCCESS: {
      const timeZones = _.get(action.payload, 'timeZones', []);
      const subscriptions = _.get(action.payload, 'subscriptions', []);
      const nodisturb = _.get(action.payload, 'nodisturb', {});
      return {
        ...state,
        subscriptions,
        nodisturb,
        timeZones,
      };
    }
    case actionTypes.GET_SETTINGS.SUCCESS: {
      const settings = action.payload;
      return {
        ...state,
        settings,
      };
    }
    case actionTypes.CREATE_ACCOUNT.SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case actionTypes.CREATE_ACCOUNT_FOR_PUBLIC_ORG.SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case actionTypes.WITHINGEOFENCE.SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case actionTypes.GETPRIVATEUSERINFO.SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case actionTypes.GETPRIVATEUSERINFO.ERROR: {
      return {
        ...state,
        ...action.error,
      };
    }
    case actionTypes.CREATE_ACCOUNT.ERROR: {
      return {
        ...state,
        ...action.error,
      };
    }
    case actionTypes.CREATE_ACCOUNT_FOR_PUBLIC_ORG.ERROR: {
      return {
        ...state,
        ...action.error,
      };
    }
    case actionTypes.ON_CHANGE_SIGNUP_FIELD:
      return {
        ...state,
        ...action.payload,
      };
    case actionTypes.MAP_PHONESMS_TO_SUBMIT:
      return {
        ...state,
        ...action.payload,
      };
    case actionTypes.FETCH_COUNTRIES.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case actionTypes.FETCH_LANGUAGE_SETTINGS.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
